var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33_3309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3886 7.03998L11.0115 10.36C10.6472 10.1845 10.2326 10.1434 9.84091 10.2441C9.44927 10.3447 9.1058 10.5805 8.87121 10.9099C8.63662 11.2392 8.526 11.6409 8.55891 12.0439C8.59182 12.447 8.76614 12.8254 9.05105 13.1123C9.33597 13.3993 9.71314 13.5762 10.1159 13.612C10.5187 13.6478 10.9212 13.54 11.2522 13.3077C11.5832 13.0755 11.8214 12.7337 11.9248 12.3427C12.0282 11.9518 11.9901 11.5369 11.8172 11.1714L15.2 7.85141L14.3886 7.03998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2857 2.4286C8.48726 2.42653 6.72579 2.93919 5.20932 3.90601C3.69285 4.87283 2.48474 6.25343 1.72765 7.88476C0.970572 9.51609 0.696148 11.33 0.936792 13.1123C1.17744 14.8946 1.9231 16.5707 3.08571 17.9429L3.25714 18.1429H17.3143L17.4857 17.9429C18.6483 16.5707 19.394 14.8946 19.6346 13.1123C19.8753 11.33 19.6008 9.51609 18.8438 7.88476C18.0867 6.25343 16.8786 4.87283 15.3621 3.90601C13.8456 2.93919 12.0842 2.42653 10.2857 2.4286ZM16.7657 17H3.80571C2.78038 15.717 2.16156 14.157 2.02857 12.52H3.99999V11.3772H2.02857C2.12426 9.56272 2.8174 7.83088 3.99999 6.45145L5.39999 7.85145L6.20571 7.04574L4.81714 5.64002C6.179 4.43633 7.90086 3.71705 9.71428 3.59431V5.59431H10.8571V3.60002C12.8603 3.74529 14.742 4.61466 16.1511 6.04581C17.5602 7.47695 18.4002 9.37202 18.5143 11.3772H16.5257V12.52H18.5429C18.4099 14.157 17.791 15.717 16.7657 17Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_3309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.5714,
    height: 20.5714,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.cf60406de6d0ca74d363404f1cc5a034.svg";
export { ForwardRef as ReactComponent };